module.exports = __webpack_public_path__ + "img/img (41).0012211c.png";